import { render, staticRenderFns } from "./KioskWelcome.vue?vue&type=template&id=20dfdd8d&scoped=true"
import script from "./KioskWelcome.vue?vue&type=script&lang=js"
export * from "./KioskWelcome.vue?vue&type=script&lang=js"
import style0 from "./KioskWelcome.vue?vue&type=style&index=0&id=20dfdd8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dfdd8d",
  null
  
)

export default component.exports